// UserProperty.model.ts

/* Propiedad (casa o departamento) a la que pertenece un usuario. Llega ÚNICAMENTE
   anidada en `data.user.properties` de GET /users/{uid}; no tiene endpoint propio.
   Aun así vive en su propio archivo: en este repo hay un archivo por entidad
   (resident-type, street-building, house-flat...) y `app-user.model.ts` ya arrastra
   XLSX, HouseFlat y StreetBuilding. Meterla ahí obligaría a importar todo eso en
   cualquier pantalla que solo necesite pintar la dirección. */

export interface IUserProperty {
  houseFlatId: string;
  number: string;
  residentTypeId: string | null;
  residentType: string | null;
  streetBuildingId: string;
  streetBuilding: string;
  neighborhoodId: string;
  neighborhood: string;
  createdAt: string;
}

export class UserProperty {
  houseFlatId: string;
  number: string;
  residentTypeId: string | null;
  residentType: string | null;
  streetBuildingId: string;
  streetBuilding: string;
  neighborhoodId: string;
  neighborhood: string;
  createdAt: Date;

  constructor(data: IUserProperty) {
    this.houseFlatId = data.houseFlatId;
    this.number = data.number;
    this.residentTypeId = data.residentTypeId;
    this.residentType = data.residentType;
    this.streetBuildingId = data.streetBuildingId;
    this.streetBuilding = data.streetBuilding;
    this.neighborhoodId = data.neighborhoodId;
    this.neighborhood = data.neighborhood;
    this.createdAt = new Date(data.createdAt);
  }

  /* Título de la tarjeta: calle o edificio + número, en ese orden, porque es como
     se dicta una dirección en voz alta. */
  get addressLabel(): string {

    const parts: string[] = [];

    if (this.streetBuilding) parts.push(this.streetBuilding);
    if (this.number) parts.push(this.number);

    return parts.length > 0
      ? parts.join(' ')
      : 'Propiedad sin dirección';
  }

  get hasNumber(): boolean {
    return !!this.number;
  }

  get numberLabel(): string {
    return this.number || 'Sin número';
  }

  get hasStreetBuilding(): boolean {
    return !!this.streetBuilding;
  }

  get streetBuildingLabel(): string {
    return this.streetBuilding || 'Sin calle o edificio';
  }

  get hasNeighborhood(): boolean {
    return !!this.neighborhood;
  }

  get neighborhoodLabel(): string {
    return this.neighborhood || 'Sin fraccionamiento';
  }

  /* `residentType` puede venir null del backend: no es un error, solo un dato que
     no se capturó. Se nombra en gris, nunca en rojo. */
  get hasResidentType(): boolean {
    return !!this.residentType;
  }

  get residentTypeLabel(): string {
    return this.residentType || 'Sin tipo de residente';
  }

}
